import {Component, Input, SimpleChanges} from '@angular/core';
import {ClaimDto} from "../../../auto-generated-server-dtos/claim/claim-dto";

@Component({
  selector: 'app-sticky-totals',
  templateUrl: './sticky-totals.component.html',
  styleUrl: './sticky-totals.component.scss'
})

export class StickyTotalsComponent {
  @Input() claimDto!: ClaimDto;
  @Input() repairTotal = 0;
  tax = 0;
  pst = 0;
  gst = 0;
  subTotal = 0;
  total = 0;
  @Input() manuallyEnteredDeductible!: number | null | undefined;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.repairTotal || changes.manuallyEnteredDeductible) {
      this.calculateTotals();
    }
  }

  setRepairTotal(total: number) {
    setTimeout(() => {
      this.repairTotal = total;
      this.calculateTotals();
    }, 0);
  }

  calculateTotals() {
    this.subTotal = this.repairTotal - (this.claimDto.manuallyEnteredDeductible ?? this.claimDto.warranty.deductible!);
    this.subTotal = this.subTotal < 0 ? 0 : this.subTotal;
    this.tax = this.subTotal * this.claimDto!.tax.rate;
    this.total = this.subTotal + this.tax;
  }
}
